import { useEffect } from 'react';
import Head from 'next/head';
import { HomeDevelopers } from '../components/home/home-developers';
import { gtm } from '../lib/gtm';

const Home = () => {
  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Head>
        <title>
          CRM ELAM-FAW
        </title>
      </Head>
      <main>
        <HomeDevelopers />
      </main>
    </>
  );
};

Home.getLayout = (page) => (
  <>
    {page}
  </>
);

export default Home;
